import { get } from 'lodash'

export const getTeamsByUser = state => get(state, 'teams.teamsByUser')
export const getTeamsByCode = state => get(state, 'teams.teamsByCode')
export const getAllTeamCodes = state => get(state, 'teams.allTeamCodes')
export const getTeamFormType = state => get(state, 'teams.teamFormType')
export const getTeamsInEvent = state => get(state, 'teams.teamsInEvent')
export const getTeamLogo = state => get(state, 'teams.teamLogoImage')
